import React, { useEffect, useState } from "react";
import {
  UserOutlined,
  MessageOutlined,
  ProfileOutlined,
  DatabaseOutlined,
  DashboardOutlined,
  TagsOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  SearchOutlined,
  DownOutlined,
  DollarOutlined,
  ShopOutlined,
  NotificationOutlined ,
  FileTextOutlined,
  RupeeOutlined,
  CalendarOutlined,
  HeartOutlined,
  AppstoreOutlined,
  FileSearchOutlined,
  WalletOutlined,
  PercentageOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { Avatar, Badge, Button, Dropdown, Input, Layout, Menu, Space, theme, Tooltip } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import RejectionModal from "./Pages/Approval/RejectionModal";
import { getSession, logout } from "../Auth/Session";
import Icon from "@ant-design/icons";

const { Header, Content, Sider } = Layout;

const siderStyle = {
  overflow: "auto",
  height: "100vh",
  position: "sticky",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: "thin",
  scrollbarGutter: "stable",
  background: "white",
};
const RupeeSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path d="M640 128H256v128h192c70.7 0 128 57.3 128 128H256v128h285.7c-19.7 57.2-73.9 96-137.7 96H256v128h128l192 192h160L512 736c106 0 194.3-73.5 218.7-172.8H832V384H730.7c-6.4-46.6-28.5-88.5-60.7-120H832V128H640z" />
  </svg>
);

const RupeeIcon = (props) => <Icon component={RupeeSvg} {...props} />;
const Main = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const navigate = useNavigate();
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(false);
  const [openRejectionModal, setOpenRejectionModal] = useState(false);




  useEffect(() => {
    const session = getSession();
    if (session) {
      session.loginTime = Date.now();
      localStorage.setItem("session", JSON.stringify(session));
    }
  });


  const onMenuClick = (e) => {
    navigate(e.key); // 👈 e.key is already the route path
  };

  const items = [
    // { key: "/main/dashboard", icon: <DashboardOutlined />, label: "Dashboard" },

    {
      key: "userManagement",
      icon: <UserOutlined />,
      label: "Manage Users",
      children: [
        {
          key: "/main/directory",
          icon: <CheckCircleOutlined />,
          label: "User Directory",
        },
        {
          key: "/main/userReports",
          icon: <FileSearchOutlined />,
          label: "Reported Users",
        },
      ],
    },
    {
      key: "master",
      icon: <AppstoreOutlined />,
      label: "Master",
      children: [
        {
          key: "/main/master",
          icon: <TagsOutlined />,
          label: "Category",
        },
        {
          key: "/main/sponsor",
          icon: <RupeeIcon style={{ color: "rgba(0,0,0,0.45)", fontSize: 16 }} />,
          label: "Sponsor",
        },
        { key: "/main/addmaster", icon: <NotificationOutlined  />, label: "Advs. master" },
        { key: "/main/events", icon: <CalendarOutlined />, label: "Events" },
        { key: "/main/forum", icon: <MessageOutlined />, label: "Forum" },
        { key: "/main/news", icon: <FileTextOutlined />, label: "News" },
        { key: "/main/donation", icon: <WalletOutlined />, label: "Donation" },
        { key: "/main/charity", icon: <HeartOutlined />, label: "Charity" },
        { key: "/main/marketplace", icon: <ShopOutlined />, label: "MarketPlace" },
        { key: "/main/vendordiscount", icon: <PercentageOutlined />, label: "VendorDiscount" }
      ],
    },



  ];

  const getSelectedKey = (pathname) => {
    if (pathname.startsWith("/main/directory")) return "/main/directory";
    if (pathname.startsWith("/main/events"))
      return "/main/events";
    if (pathname.startsWith("/main/donation"))
      return "/main/donation";
    if (pathname.startsWith("/main/news"))
      return "/main/news";
     if (pathname.startsWith("/main/addmaster")) return "/main/addmaster";
    if (pathname.startsWith("/main/charity")) return "/main/charity";
    if (pathname.startsWith("/main/forum")) return "/main/forum";
    if (pathname.startsWith("/main/market")) return "/main/marketplace";
    if (pathname.startsWith("/main/vendor")) return "/main/vendordiscount";
    if (pathname.startsWith("/main/reports")) return "/main/reports";

    return pathname;
  };



  const [language, setLanguage] = useState("English");

  // User dropdown menu
  const userMenu = {
    items: [
      {
        key: "change_pwd",
        label: "Change Password",
        onClick: () => navigate("/changePassword"),
      },
      {
        key: "logout",
        label: "Logout",
        onClick: () => setOpenRejectionModal(true),
      },
    ],
  };



  // Language dropdown
  const languageMenu = (
    <Menu
      items={[
        { key: "en", label: "English", onClick: () => setLanguage("English") },
        { key: "fr", label: "French", onClick: () => setLanguage("French") },
      ]}
    />
  );


  return (
    <Layout>
      <Sider
        style={siderStyle}
        trigger={null}
        collapsible
        width={220}
        collapsedWidth={80}
        collapsed={collapsed}
        className="main-kopa"
      >
        {collapsed ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px 10px",
            }}
          >
            <img src="/collapsLogo.png" alt="Logo" style={{ width: "90%" }} />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "30px 10px",
            }}
          >
            <img src="/Logo.png" alt="Logo" style={{ width: "90%" }} />
          </div>
        )}

        <Menu
          theme="light"
          mode="inline"
          defaultOpenKeys={["userManagement"]}
          selectedKeys={[getSelectedKey(location.pathname)]}
          items={items}
          style={{
            border: "none",
            paddingLeft: "10px"
          }}
          onClick={onMenuClick}
        />
      </Sider>

      <Layout>
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
            position: "sticky",
            top: 0,
            zIndex: 1,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingRight: "20px"
          }}
        >
          <Tooltip title={collapsed ? 'Open Sidebar' : 'Close Sidebar'}>
            <Space size="large">
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{
                  fontSize: "16px",
                  width: 64,
                  height: 64,
                }}
              />
            </Space>
          </Tooltip>

          {/* Right - Notifications, Language, User */}
          <Space size="large">
            {/* Notification Bell */}
            {/* <Badge count={6} offset={[-2, 2]}>
              <BellOutlined style={{ fontSize: 20 }} />
            </Badge>

            {/* Language Dropdown 
            <Dropdown menu={languageMenu} trigger={["click"]}>
              <Space>
                <img
                  src="https://flagcdn.com/w20/gb.png"
                  alt="flag"
                  style={{ width: 24, height: 16 }}
                />
                {language}
                <DownOutlined style={{ fontSize: 10 }} />
              </Space>
            </Dropdown> */}

            {/* User Profile */}
            <Dropdown menu={userMenu} trigger={["click"]}>
              <Space style={{ cursor: "pointer" }}>
                <Avatar
                  icon={<UserOutlined />}
                  size="large"
                />
                <div style={{ lineHeight: 1 }}>
                  <small style={{ color: "gray", fontWeight: '600' }}>Admin</small>
                </div>
                <DownOutlined style={{ fontSize: 10 }} />
              </Space>
            </Dropdown>
            {/* <Tooltip title='Change Password'>
              <Button  onClick={() => navigate("/changePassword")}>
                Change Password
              </Button>
            </Tooltip>

            <Tooltip title='Logout from this application'>
              <Button onClick={() => setOpenRejectionModal(true)}>
                Logout
              </Button>
            </Tooltip> */}
          </Space>
        </Header>

        <Content>
          <div
            style={{
              padding: 24,
            }}
          >
            {/* 👇 Renders nested routes here */}
            <Outlet />
          </div>
        </Content>
      </Layout>
      {openRejectionModal &&
        <RejectionModal
          title='Log out'
          content='Are you sure you want Log out from this application ?'
          open={openRejectionModal}
          buttonName='Logout'
          onClose={() => setOpenRejectionModal(false)}
          onSubmit={logout}
        />
      }

    </Layout>
  );
};

export default Main;
